import { axiosClient, axiosSSOConfigPrivate } from '../../rest-client';
import { API_CUSTOM_FILES_GET } from './urls';

export const getCustomFiles = async (params) =>
  axiosClient.get(API_CUSTOM_FILES_GET, axiosSSOConfigPrivate({}, { params: params }));
